import { create } from 'zustand'
import InputValidateFactory from '../factories/InputValidateFactory'

const useFormStore = create((set, get) => ({
  formName: null,
  formData: {},
  formErrors: {},
  loading: false,
  hideButton: false,

  setField: (name, value) => set((state) => ({
    formData: { ...state.formData, [name]: value }
  })),

  setError: (fieldName, error) => set(state => {
    const newErrors = { ...state.formErrors }
    
    if (error) {
      newErrors[fieldName] = error
    } else {
      delete newErrors[fieldName]
    }

    return { formErrors: newErrors }
  }),

  validateField: (type, name) => {
    const value = get().formData[name] || ''
    if (value === '' || value === null) {
      get().setError(name, 'Campo obrigatório')
    } else {
      const validation = InputValidateFactory.factory(type, value)
      if (!validation.success) {
        get().setError(name, validation.message)
      } else {
        get().setError(name, null)
      }
    }
  },

  resetForm: () => set({ formData: {}, formErrors: {}, loading: false, hideButton: false }),
}))

export default useFormStore
